(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2521],{

/***/ 22553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ esm_grid; }
});

// UNUSED EXPORTS: StyledGridContainer, StyledGridItem

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@nextui-org/react/esm/utils/clsx.js
var clsx = __webpack_require__(61309);
// EXTERNAL MODULE: ./node_modules/@nextui-org/react/esm/utils/with-defaults.js
var with_defaults = __webpack_require__(50088);
// EXTERNAL MODULE: ./node_modules/@nextui-org/react/esm/theme/stitches.config.js + 1 modules
var stitches_config = __webpack_require__(86212);
;// CONCATENATED MODULE: ./node_modules/@nextui-org/react/esm/grid/grid.styles.js
const StyledGridContainer=(0,stitches_config/* styled */.zo)("div",{});const StyledGridItem=(0,stitches_config/* styled */.zo)("div",{margin:0,boxSizing:"border-box",padding:"$$gridGapUnit"});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@nextui-org/react/esm/grid/grid-item.js
const l=t=>{const s=0===t?"none":"inherit";if("number"==typeof t){const e=100/12*t,i=e>100?"100%":e<0?"0":`${e}%`;return{flexGrow:0,display:s,maxWidth:i,flexBasis:i}}return{flexGrow:1,display:s,maxWidth:"100%",flexBasis:"0"}},n=react.forwardRef((({xs:t,sm:i,md:n,lg:o,xl:x,css:a,justify:d,direction:c,alignItems:f,alignContent:u,children:g,className:p,...y},h)=>{const j=(0,react.useMemo)((()=>{const s={xs:t,sm:i,md:n,lg:o,xl:x};return Object.keys(s).reduce(((t,e)=>void 0!==s[e]&&!1!==s[e]?`${t} ${e}`:t),"").trim()}),[t,i,n,o,x]);return (0,jsx_runtime.jsx)(StyledGridItem,{ref:h,className:(0,clsx/* default */.Z)("nextui-grid-item",j,p),css:{alignItems:f,alignContent:u,justifyContent:d,flexDirection:c,"&.xs":{...l(t)},"@xsMax":{"&.xs":{...l(t)}},"@sm":{"&.sm":{...l(i)}},"@md":{"&.md":{...l(n)}},"@lg":{"&.lg":{...l(o)}},"@xl":{"&.xl":{...l(x)}},...a},...y,children:g})}));n.displayName="NextUI.GridItem",n.toString=()=>".nextui-grid-item";/* harmony default export */ var grid_item = ((0,with_defaults/* default */.Z)(n,{xs:!1,sm:!1,md:!1,lg:!1,xl:!1,className:""}));
;// CONCATENATED MODULE: ./node_modules/@nextui-org/react/esm/grid/grid.js
const i=react.forwardRef((({children:r,css:i,...o},m)=>(0,jsx_runtime.jsx)(grid_item,{ref:m,css:{...i},...o,children:r})));i.displayName="NextUI.Grid",i.toString=()=>".nextui-grid";/* harmony default export */ var grid = (i);
;// CONCATENATED MODULE: ./node_modules/@nextui-org/react/esm/grid/grid-container.js
const c=react.forwardRef((({gap:r,wrap:t,css:c,children:o,className:n,...p},l)=>{const m=(0,react.useMemo)((()=>`calc(${r} * $space$3)`),[r]);return (0,jsx_runtime.jsx)(grid_item,{ref:l,className:(0,clsx/* default */.Z)("nextui-grid-container",n),css:{$$gridGapUnit:m,display:"flex",flexWrap:t,boxSizing:"border-box",margin:"calc(-1 * $$gridGapUnit)",width:"calc(100% + $$gridGapUnit * 2)",...c},...p,children:o})}));c.displayName="NextUI.GridContainer",c.toString=()=>".nextui-grid-container";/* harmony default export */ var grid_container = ((0,with_defaults/* default */.Z)(c,{gap:0,wrap:"wrap",className:""}));
;// CONCATENATED MODULE: ./node_modules/@nextui-org/react/esm/grid/index.js
grid.Container=grid_container;/* harmony default export */ var esm_grid = (grid);

/***/ }),

/***/ 39212:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about",
      function () {
        return __webpack_require__(14228);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 14228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _nextui_org_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28723);
/* harmony import */ var _nextui_org_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64040);
/* harmony import */ var _nextui_org_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86979);
/* harmony import */ var _nextui_org_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7087);
/* harmony import */ var _nextui_org_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22553);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);



var AboutPage = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: "⚡SVRN Energy⚡ - About"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                children: "About"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_nextui_org_react__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                children: "SVRNs"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_nextui_org_react__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_nextui_org_react__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    children: "SVRN Energy wants to change the world for the better and make Bitcoin & Sovereignty easily accessible for everyone!"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_nextui_org_react__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_nextui_org_react__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                h3: true,
                children: "Credits"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_nextui_org_react__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_nextui_org_react__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    children: [
                        "SVRN Energy is built on Open Source Software. Checkout the projects that inspired and power SVRN Energy.",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "- Backend built with",
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_nextui_org_react__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                            href: "https://github.com/lightsats/lightsats",
                            css: {
                                display: "inline"
                            },
                            children: "Lightsats"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_nextui_org_react__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_nextui_org_react__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    children: [
                        "- 3d icons by",
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_nextui_org_react__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                            href: "https://vijayverma.co/",
                            css: {
                                display: "inline"
                            },
                            children: "realvjy"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_nextui_org_react__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                children: "Links"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_nextui_org_react__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Container */ .ZP.Container, {
                gap: 1,
                justify: "center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_nextui_org_react__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_nextui_org_react__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                            href: "https://github.com/lightsats/lightsats",
                            target: "_blank",
                            children: "Github"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_nextui_org_react__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_nextui_org_react__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                            href: "https://twitter.com/svrnenergy",
                            target: "_blank",
                            children: "Twitter"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (AboutPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(39212); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);